import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../reports.scss";

import SLE_logo from "../../../assets/images/SriLalitha_Logo.png";
// import "../app-invoice.css";
import { getRFQDocReport } from "../../../store/Reports/actions";
import {
  getQuotationsData,
  getRFQRequestdata,
} from "../../../store/CompareQuotation/actions";
class RFQVendorWiseReportDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // Use the same API calls as CompareQuotation to get quotation data
    const rfqId = this.props.match.params.id;

    // First get RFQ data, then quotations (like CompareQuotation does)
    // this.props.getRFQRequestdata(rfqId);
    this.props.getQuotationsData(rfqId);
  }

  getPDFReport = async () => {
    const element = document.getElementById("toPdf");
    if (!element) return;

    const originalWidth = element.style.width;
    element.style.width = "297mm";
    element.style.maxWidth = "290mm";

    const pdf = new jsPDF("1", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // Use a higher scale for better text clarity
    const canvas = await html2canvas(element, {
      scale: 1.5,
      useCORS: true,
      scrollX: 0,
      scrollY: 0,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position -= pageHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save("Request_For_Quotation_Vendor_Wise.pdf");

    // Revert back to original
    element.style.width = originalWidth;
  };
  reportBody() {
    return (
      <Row className="p-1 report-preview">
        <Col md={12} className="p-1">
          <Card className="p-1 report-preview-card">
            <CardBody className="report-padding pb-0">
              {/* HEADER */}
              <div className="report-body d-flex align-items-center justify-content-between mt-0">
                {/* Empty left spacer */}
                <div style={{ width: "25%" }}></div>

                {/* CENTER TITLE */}
                <div style={{ width: "50%" }} className="text-center">
                  <h3 className="card-title-16 pt-2 mb-0">
                    SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                  </h3>
                </div>

                {/* RIGHT DATE */}
                <div style={{ width: "25%" }} className="text-right">
                  <div className="report-wrapper">
                    <p className="report-wrapper-title mb-0">Submitted On:</p>
                    <p className="report-wrapper-det mb-0">
                      {moment(this.props.RFQ_Doc_report.createdon).format(
                        "DD-MM-YYYY"
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <hr className="hr-black-color" />
              {this.renderComparisonTable && this.renderComparisonTable()}{" "}
              {/* <div className=" card-title-14 mt-2  mb-0">
                <p>Vendors List</p>
              </div> */}
              <hr className="hr-black-color " />
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  renderComparisonTable() {
    const quotationData = this.props.CQbodyData || [];
    const rfqCellData = this.props.RFQCellData || [];
    const VENDORS_PER_PAGE = 2;

    if (!quotationData.length) {
      return (
        <div className="text-center p-4">
          <h5>No quotation data available</h5>
        </div>
      );
    }

    // ---------- BUILD VENDORS ----------
    const allVendors = [];
    rfqCellData.forEach((cell, index) => {
      if (index !== 0 && cell.vendId) {
        allVendors.push({
          id: cell.vendId,
          name: cell.headerName,
          cellKey: cell.CellName,
        });
      }
    });

    // ---------- SPLIT INTO PAGES ----------
    const vendorChunks = [];
    for (let i = 0; i < allVendors.length; i += VENDORS_PER_PAGE) {
      vendorChunks.push(allVendors.slice(i, i + VENDORS_PER_PAGE));
    }

    const rows = quotationData.filter((row) => row.ItemName);

    return vendorChunks.map((vendors, pageIndex) => (
      <div
        key={pageIndex}
        style={{
          pageBreakAfter:
            pageIndex === vendorChunks.length - 1 ? "auto" : "always",
        }}
      >
        <Table
          bordered
          className="mb-4 table-centered table-color-black"
          style={{ tableLayout: "fixed" }}
        >
          <thead className="bg-light text-center">
            <tr>
              <th rowSpan={2}>S.NO</th>
              <th rowSpan={2} style={{ width: "260px" }}>
                DESCRIPTION
              </th>
              <th rowSpan={2}>UOM</th>
              <th rowSpan={2}>QTY</th>

              {vendors.map((vendor) => (
                <th key={vendor.id} colSpan={6}>
                  {vendor.name}
                </th>
              ))}
            </tr>

            <tr>
              {vendors.map((vendor) => (
                <React.Fragment key={vendor.id}>
                  <th>MAKE</th>
                  <th>RATE</th>
                  <th>DISC %</th>
                  <th>DISC VALUE</th>
                  <th>TAX</th>
                  <th>VALUE</th>
                </React.Fragment>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((row, idx) => {
              const item = row.ItemName;

              return (
                <tr key={item.rfqItemId}>
                  <td className="text-center">{idx + 1}</td>

                  <td style={{ wordBreak: "break-word" }}>
                    <b>{item.Name}</b>
                    <div className="text-muted">{item.description || "-"}</div>
                  </td>

                  <td className="text-center">{item.Quantity_unit?.name}</td>
                  <td className="text-center">{item.Quantity}</td>

                  {vendors.map((vendor) => {
                    const vData = row[vendor.cellKey] || {};

                    return (
                      <React.Fragment key={vendor.id}>
                        <td>{vData.make || "-"}</td>
                        <td>
                          {vData.Price
                            ? `₹ ${Number(vData.Price).toFixed(2)}`
                            : "-"}
                        </td>
                        <td>
                          {vData.discountpercent
                            ? `${vData.discountpercent}%`
                            : "-"}
                        </td>
                        <td>{vData.discount ? `₹ ${vData.discount}` : "-"}</td>
                        <td>
                          {vData.taxtype === 1
                            ? "Inclusive"
                            : vData.taxtype === 2
                            ? "Exclusive"
                            : "-"}
                        </td>

                        <td className="text-center">
                          {Number(vData?.updateGrossValue) > 0
                            ? `₹ ${Number(
                                vData.updateGrossValue
                              ).toLocaleString()}`
                            : vData?.GrossValue
                            ? `₹ ${Number(vData.GrossValue).toLocaleString()}`
                            : "-"}
                        </td>
                      </React.Fragment>
                    );
                  })}
                </tr>
              );
            })}

            {/* TOTALS */}
            <tr className="compare-total-row">
              <td colSpan={4}>
                <b>Total</b>
              </td>
              {vendors.map((v) => (
                <td key={v.id} colSpan={6} className="text-center">
                  ₹ {this.props.CQVendorTotals?.[v.id]?.total || 0}
                </td>
              ))}
            </tr>

            <tr className="compare-gst-row">
              <td colSpan={4}>
                <b>GST</b>
              </td>
              {vendors.map((v) => (
                <td key={v.id} colSpan={6} className="text-center">
                  ₹ {this.props.CQVendorTotals?.[v.id]?.gst || 0}
                </td>
              ))}
            </tr>

            <tr className="compare-grandtotal-row">
              <td colSpan={4}>
                <b>Grand Total</b>
              </td>
              {vendors.map((v) => (
                <td key={v.id} colSpan={6} className="text-center">
                  ₹ {this.props.CQVendorTotals?.[v.id]?.grand_total || 0}
                </td>
              ))}
            </tr>
          </tbody>
        </Table>
      </div>
    ));
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print ">
                    <Link
                      to="#"
                      onClick={() => this.props.history.goBack()}
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    {/* {this.props.rfqPDF ? (
                      <Link
                        // to="/rfqdashboard"
                        onClick={() => this.props.history.goBack()}
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                    ) : (
                      <Link
                        to="/rfqreport"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                    )} */}
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => this.getPDFReport()}
                        >
                          <i className="ri-file-excel-2-line"></i>
                          <span className="d-none d-inline-block ml-1">
                            PDF
                          </span>
                        </Button>

                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => {
                            window.focus();
                            window.print();
                          }}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody
                    className="pt-1 mr-auto mx-auto"
                    id="toPdf"
                    // style={{ width: "297mm" }}
                  >
                    {this.reportBody()}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { RFQ_Doc_report, rfqPDF } = state.reports;
  const { RFQCellData, CQbodyData, RFQrowdata, CQVendorTotals } =
    state.CompareQuotation;
  return {
    RFQ_Doc_report,
    rfqPDF,
    RFQCellData,
    CQbodyData,
    RFQrowdata,
    CQVendorTotals,
  };
};

export default connect(mapStatetoProps, {
  getRFQDocReport,
  getQuotationsData,
  getRFQRequestdata,
})(RFQVendorWiseReportDocument);
